import { Component, ViewChild, NgZone } from "@angular/core";
import { IonicApp, Platform, Nav } from "ionic-angular";

import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";
import { Keyboard } from "@ionic-native/keyboard";

import { HomePage } from "../pages/home/home";
import { ProductsPage } from "../pages/products/products";
import { TabOrder } from "../pages/orders/tabs/tab-order";
import { TabAddOrder } from "../pages/addorder/tabs/tab-addorder";
import { TabSettlement } from "../pages/settlement/tabs/tab-settlement";
import { TabInventory } from "../pages/inventory/tabs/tab-inventory";
import { Network } from "@ionic-native/network";
import { AppVersion } from "@ionic-native/app-version";

import { LoginPage } from "../pages/login/login";

import { LocationTracker } from "../common/services/location-tracker";
import { SqlLiteService } from "../common/services/sqllite.service";
import { APIServiceProvider } from "../common/services/api.service";
import { HelperServiceProvider } from "./../common/services/helper.service";
import * as JWT from "jwt-decode";
import { FarmersPage } from "../pages/farmers/farmers";
import { UserService } from "../services/user.service";
import { FirebaseService } from "../services/firebase.service";
import { MixpanelService } from "../services/mixpanel.service";
import { OrdercancelledPage } from "../pages/orders/ordercancelled/ordercancelled";
import { environment } from "./../environments/environment";
import { SocketioService } from "./../common/services/socketio.service";
import { PagesBankReceiptPage } from "../pages/pages-bank-receipt/pages-bank-receipt";
import { BankReceiptHistoryPage } from "../pages/bank-receipt-history/bank-receipt-history";

@Component({
    templateUrl: "app.html"
})
export class MyApp {
    selectedTheme: String;
    isLoggedIn: boolean = false;
    showedAlert: boolean;

    @ViewChild(Nav)
    nav: Nav;

    rootPage: any;

    user_img: any;

    decodedToken: any = null;
    user = {
        name: null
    };

    public isOnline: boolean = false;
    public isProduction: boolean = environment.production;

    public counter = 0;
    public app_version_number: any = null;

    constructor(
        public platform: Platform,
        public zone: NgZone,
        public statusBar: StatusBar,
        private appVersion: AppVersion,
        public socketService: SocketioService,
        private network: Network,
        public apiService: APIServiceProvider,
        public locationTracker: LocationTracker,
        public splashScreen: SplashScreen,
        private ionicApp: IonicApp,
        public sqlLiteService: SqlLiteService,
        public helperService: HelperServiceProvider,
        public keyboard: Keyboard,
        private userService: UserService,
        private firebase: FirebaseService,
        private mixpanel: MixpanelService
    ) {
        this.initializeApp();
    }

    initializeApp() {
        let self = this;

        this.userService.appMenuItems = [
            { title: "Home", component: HomePage, icon: "home" },
            { title: "Add Opportunity", component: TabAddOrder, icon: "cart" },
            { title: "My Orders", component: TabOrder, icon: "list" },
            { title: "My Farmers", component: FarmersPage, icon: "people" },
            { title: "Products", component: ProductsPage, icon: "construct" },
            { title: "Settlements", component: TabSettlement, icon: "cash" },
            { title: "Upload Bank Receipt", component: PagesBankReceiptPage, icon: "cash" },
            { title: "Bank Receipt History", component: BankReceiptHistoryPage, icon: "list" },

            {
                title: "Cancelled Orders",
                component: OrdercancelledPage,
                icon: "close-circle"
            },
            { title: "Inventory", component: TabInventory, icon: "clipboard" }
        ];

        this.userService.userStatusChanged.subscribe(e => {
            this.user = {
                name: localStorage.getItem("user-name")
            };
            this.decodedToken = JWT(localStorage.getItem("gp_token"));
        });

        this.platform.ready().then(() => {
            this.firebase.initFirebase();
            this.mixpanel.init();

            this.handelGlobalEvents();

            if (localStorage.getItem("gp_token")) {
                this.user = {
                    name: localStorage.getItem("user-name")
                };
                this.decodedToken = JWT(localStorage.getItem("gp_token"));
            }

            //Confirmation exit
            this.platform.registerBackButtonAction(() => {
                let activeModal = this.ionicApp._modalPortal.getActive();

                if (activeModal) {
                    activeModal.dismiss();
                    return;
                }

                if (this.nav.length() == 1) {
                    this.confirmExitApp();
                }
                this.nav.pop();
            }, 0);

            // Okay, so the platform is ready and our plugins are available.

            //*** Control Splash Screen
            // this.splashScreen.show();
            // this.splashScreen.hide();

            //*** Control Status Bar
            this.statusBar.styleDefault();
            this.statusBar.overlaysWebView(false);

            //*** Control Keyboard
            //this.keyboard.disableScroll(true);

            if (this.platform.is("cordova")) {
                // Initilizing the sqllite here
                this.sqlLiteService.bootup();

                this.registerNetwork();
                this.checkAppVersion();

                this.appVersion.getVersionNumber().then(function(version) {
                    self.app_version_number = version;
                });
            }

            if (localStorage.getItem("gp_token")) {
                this.locationTracker.startTracking();

                this.apiService.post("health/check", {}).subscribe(
                    response => {
                        if (response["data"]) {
                            this.nav.setRoot(HomePage);
                        } else {
                            this.nav.setRoot(LoginPage);
                        }
                    },
                    error => {
                        this.nav.setRoot(LoginPage);
                    }
                );
            } else {
                this.nav.setRoot(LoginPage);
            }
        });
    }

    handelGlobalEvents() {
        this.socketService.socket.on("guhardrefresh", data => {
            console.log("Refreshing the cache...");
            location.reload(true);
        });

        this.socketService.socket.on("gulogout", data => {
            console.log("Logging out...");
            this.logout();
        });
    }

    checkAppVersion() {
        let self = this;

        this.appVersion.getVersionCode().then(function(version) {
            let postData: any = {};

            postData.app_version = version;

            self.apiService
                .post("auth/fieldapp/check-version", postData)
                .subscribe(result => {
                    var force_update = result["force_update"];
                    var soft_update = result["soft_update"];
                    var message = result["message"];
                    var title = result["title"];

                    if (force_update || soft_update) {
                        self.helperService.updateTheApp(
                            force_update,
                            title,
                            message
                        );
                    }
                });
        });
    }

    openPage(page) {
        let self = this;

        localStorage.setItem(
            "manager_user_id",
            localStorage.getItem("user-id")
        );

        if (page.title === "My Orders") {
            this.nav.push(page.component);

            setTimeout(function() {
                self.nav.getActiveChildNav().select(1);
            }, 100);

            return true;
        }

        if (page.title === "My Team") {
            this.nav.push(page.component, {
                manager_id: localStorage.getItem("user-id")
            });
            return true;
        }

        if (page.title === "Home") {
            this.nav.setRoot(page.component);
        } else {
            this.nav.push(page.component);
        }
    }

    confirmExitApp() {
        if (this.counter == 0) {
            this.counter++;
            this.helperService.presentToast("Press again to exit..");
            setTimeout(() => {
                this.counter = 0;
            }, 3000);
        } else {
            this.platform.exitApp();
        }
    }

    registerNetwork() {
        let parent = this;

        this.network.onConnect().subscribe(
            data => {
                if (!parent.isOnline) parent.isOnline = true;
                this.helperService.presentToast(
                    "You are now connected to the internet"
                );

                parent.zone.run(() => {
                    parent.helperService.has_internet = true;
                });
            },
            error => console.error(error)
        );

        this.network.onDisconnect().subscribe(
            data => {
                if (parent.isOnline) parent.isOnline = false;
                this.helperService.presentToast(
                    "You have lost the internet connection"
                );

                parent.zone.run(() => {
                    parent.helperService.has_internet = false;
                });
            },
            error => console.error(error)
        );
    }

    logout() {
        const self = this;

        localStorage.removeItem("gp_token");
        localStorage.removeItem("user-id");
        localStorage.removeItem("user_depo_id");
        localStorage.removeItem("user_depo_name");
        localStorage.removeItem("user-name");
        localStorage.removeItem("firebase-login");
        localStorage.removeItem("gp_img");

        localStorage.removeItem("manager_user_id");

        this.firebase.Auth.signOut()
            .then(function() {
                self.nav.setRoot(LoginPage);
            })
            .catch(function(error) {});
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts